// extracted by mini-css-extract-plugin
export default {"itemCourse":"Order_itemCourse__0Yh4N"};